module.exports = __webpack_public_path__ + "order/img/ca.ad152714.svg";